import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BlobResponse, ContentAndStatus } from '../../Models/OtherClasses';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class PropertyItemDocumentService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('PropertyItemDocument');
	}
	loadAllForTask(id: System.Guid): Observable<TooBig4Car.Logic.PropertyItemDocument[]> {
		return this.myBaseService.loadAll(this.url + '/ForChecklistTask/' + (id || ''));
	}
	loadAllForItem(id: System.Guid): Observable<TooBig4Car.Logic.PropertyItemDocument[]> {
		return this.myBaseService.loadAll(this.url + '/ForItem/' + (id || ''));
	}
	loadAllForPickupDelivery(id: System.Guid): Observable<TooBig4Car.Logic.PropertyItemDocument[]> {
		return this.myBaseService.loadAll(this.url + '/ForPickupDelivery/' + (id || ''));
	}
	loadAllForPickupDeliveryItem(id: System.Guid): Observable<TooBig4Car.Logic.PropertyItemDocument[]> {
		return this.myBaseService.loadAll(this.url + '/ForPickupDeliveryItem/' + (id || ''));
	}
	loadAllForInspection(id: System.Guid): Observable<TooBig4Car.Logic.PropertyItemDocument[]> {
		return this.myBaseService.loadAll(this.url + '/ForInspection/' + (id || ''));
	}
	loadAllForTypePropertyItem(id: System.Guid): Observable<TooBig4Car.Logic.PropertyItemDocument[]> {
		return this.myBaseService.loadAll(this.url + '/ForType/' + (id || ''));
	}
	togglePurpose(id: System.Guid, vals: number[]): Observable<TooBig4Car.Logic.PropertyItemDocument> {
		return this.myBaseService.post(vals, this.url + '/TogglePurpose/' + (id || ''), true);
	}
	rotate(id: System.Guid): Observable<TooBig4Car.Logic.PropertyItemDocument> {
		return this.myBaseService.post(null, this.url + '/Rotate/' + (id || ''), true);
	}
	save(tempItem: TooBig4Car.Logic.ObjectBase): Observable<TooBig4Car.Logic.PropertyItemDocument> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	downloadDoc(id: System.Guid): Observable<BlobResponse> {
		return this.myBaseService.loadBlob(this.url + '/Content/' + id);
	}
	downloadThumb(id: System.Guid, qs: string): Observable<BlobResponse> {
		var iUrl = this.url + '/ThumbContent/' + id;
		if (qs) {
			iUrl += '?qs=' + qs;
		}
		return this.myBaseService.loadBlob(iUrl);
	}

	
	downloadThumbForTypePropertyItem(id: System.Guid): Observable<ContentAndStatus<BlobResponse>> {
		return this.myBaseService.loadBlobAndHeaders(this.url + '/ThumbForType/' + id);
	}
	downloadThumbForPropertyItem(id: System.Guid): Observable<ContentAndStatus<BlobResponse>> {
		return this.myBaseService.loadBlobAndHeaders(this.url + '/ThumbForItem/' + id);
	}
	downloadThumbForPickupDeliveryItem(id: System.Guid): Observable<ContentAndStatus<BlobResponse>> {
		return this.myBaseService.loadBlobAndHeaders(this.url + '/ThumbForPDItem/' + id);
	}
}

